import { Fragment, memo } from 'react';
import Accountholder from '../shared/accountholder';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';

interface StatementFormProps {
  disabled?: boolean;
}

const StatementFormComponent = ({ disabled }: StatementFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} hasAccountholder={false} isDeclaration />
      <Accountholder disabled isDeclaration />
    </Fragment>
  );
};

StatementFormComponent.displayName = 'Statement Form component';

const StatementForm = memo(StatementFormComponent);

export default StatementForm;
